import {motion} from "framer-motion"
import React from "react"

import CurveSvg from "./CurveSvg"
import styles from "./HomeHeroAnimated.module.scss"
import SlideProgressIndicators from "./SlideProgressIndicators"

interface HeroCurveBackgroundProps {
	backgroundVideoDesktop?: any
	refProp: React.RefObject<SVGSVGElement>
	backgroundColor: string
	slideCount: number
	activeIndex: number
	autoDuration: number
	onChange: (index: number) => void
}

const HeroCurveBackground: React.FC<HeroCurveBackgroundProps> = ({
	backgroundVideoDesktop,
	refProp,
	backgroundColor,
	activeIndex,
	autoDuration,
	onChange,
	slideCount,
}) => {
	return (
		<div
			className={styles.svgCurleBackground}
			style={{
				position: "relative",
				height: "105%",
				top: "0px",
			}}
		>
			<motion.div
				className={`${
					backgroundVideoDesktop ? styles.backgroundTransparent : ""
				} ${styles.beforeBottomWhite}`}
				style={{
					padding: 0,
				}}
				initial={false}
				animate={{backgroundColor}}
				transition={{duration: 0.6, ease: "easeInOut"}}
			>
				<CurveSvg ref={refProp} />
			</motion.div>
			<div
				style={{
					position: "absolute",
					top: "75px",
					left: "0px",
					display: "flex",
					gap: "1rem",
					zIndex: 10,
					background: "white",
				}}
				className={styles.timerPosition}
			>
				<SlideProgressIndicators
					slideCount={slideCount}
					activeIndex={activeIndex}
					autoDuration={autoDuration}
					onChange={onChange}
				/>
			</div>
		</div>
	)
}

export default HeroCurveBackground
